import React, { useState } from "react";
import { observer } from "mobx-react";
import FileIcon from "Assets/svg/linkedinTemplate/fileIcon.svg";
import RightArrowIcon from "Assets/svg/linkedinTemplate/rightArrowIcon.svg";
import { withRouter } from "react-router-dom";
import Button from "Components/common/Button";
import { linkedInTemplatePopupState } from "./LinkedInTemplatePopupState";
import { seqTemplatePopupState } from "./SequenePredefinedTemplate/SeqTemplatePopupState";
import Utils from "Utils/utils";

const LinkedInTemplatesListPopup = observer((props) => {
  const {
    showTemplatesListPopup,
    setShowTemplatesListPopup,
    setShowPopup,
    templates,
    templatesLoader,
    fetchLinkedInTemplates,
    applyLinkedInTemplate,
    applyTemplateLoader,
    selectedTemplate,
    setSelectedTemplate
  } = linkedInTemplatePopupState;

  React.useEffect(() => {
    if (showTemplatesListPopup) {
      fetchLinkedInTemplates();
    }
  }, [showTemplatesListPopup]);

  if (!showTemplatesListPopup) return null;

  const handleClose = () => {
    setShowTemplatesListPopup(false);
    seqTemplatePopupState.setAction("");
  };

  const handleBack = () => {
    setShowTemplatesListPopup(false);
    seqTemplatePopupState.setAction("");
  };

  const handleUseTemplate = () => {
    if (selectedTemplate && !applyTemplateLoader) {
      const folderId = Utils.getFolderDetails()?.folderId;
      applyLinkedInTemplate(selectedTemplate.id, folderId, props.history);
    }
  };

  return (
    <div className="linkedinTemplatesListPopupSection">
      <div className="card animated customzoomIn">
        <div className="popupHeader">
          <h2 className="title">LinkedIn Sequence Templates</h2>
          <i className="material-icons closeIcon" onClick={handleClose}>
            close
          </i>
        </div>
        <div className="templatesListWrapper">
          {templatesLoader ? (
            <div className="loaderWrapper">
              <div className="loader"></div>
              <p>Fetching templates...</p>
            </div>
          ) : templates.length > 0 ? (
            <div className="listContainer">
              {templates.map((template, index) => {
                const isSelected = selectedTemplate === template;
                return (
                  <div
                    key={template._id || template.id || template.name || index}
                    className={`templateItem ${isSelected ? "selected" : ""}`}
                    onClick={() => {
                      setSelectedTemplate(template);
                    }}
                  >
                  <img src={FileIcon} className="fileIcon" alt="Template" />
                  <div className="templateInfo">
                    <span className="linkedinTemplateName">{template.name}</span>
                    {template.description && (
                      <span className="linkedinTemplateDescription">
                        {template.description}
                      </span>
                    )}
                  </div>
                  <img
                    src={RightArrowIcon}
                    className="arrowIcon"
                    alt="Select"
                  />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="noTemplates">No templates found</div>
          )}
        </div>
        <div className="popupFooter">
          <button className="backBtn" onClick={handleBack}>
            Back
          </button>
          <Button
            btnText="Use template"
            className="useTemplateBtn"
            disabled={!selectedTemplate || templatesLoader || applyTemplateLoader}
            loader={applyTemplateLoader}
            click={handleUseTemplate}
          />
        </div>
      </div>
      <div className="overlayMaskPopup" onClick={handleClose}></div>
    </div>
  );
});

export { LinkedInTemplatesListPopup };
export default withRouter(LinkedInTemplatesListPopup);
